// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bluejay." + chunkId + "." + {"recorder":"d5f8516db213570be7ab","default-localization_src_translations_en-ca_json":"39955ed430c9f8cde063","default-localization_src_translations_platform_en-us_json":"ccd22b48d4954ce1c70b"}[chunkId] + ".js";
};